import { LayoutDefinition } from '../dashboard/layout'
import {
  addPanel,
  addPanels,
  configurePanelAt,
  movePanelTo,
  removePanelAt,
  removePanels,
  resizePanelAt,
  showPanelAt,
} from '../dashboard/layoutOperations'
import type { LayoutControls } from './useDashboardLayout'

export const makeLayoutControls = (
  layout: LayoutDefinition,
  apply: (next: LayoutDefinition) => void,
  reset: () => void
): LayoutControls => ({
  show: (index, panel) => apply(showPanelAt(layout, index, panel)),
  resize: (index, span) => apply(resizePanelAt(layout, index, span)),
  moveTo: (from, to) => apply(movePanelTo(layout, from, to)),
  remove: (index) => apply(removePanelAt(layout, index)),
  add: (panel) => apply(addPanel(layout, panel)),
  addMany: (panels) => apply(addPanels(layout, panels)),
  removeMany: (panels) => apply(removePanels(layout, panels)),
  configure: (index, config) => apply(configurePanelAt(layout, index, config)),
  reset,
})
